<!-- 登录页 -->
<template>
  <div class="filmWrapTact">
    <div class="paymentLiTact">
      <div class="paymentListTact_choicecontact">
        <ul>
          <li v-for="(item,index) in docslist" :key="item.id">
            <div class="checkWrapTact L">
              <input type="checkbox" :value="item.id" v-on:click="choice($event,index,item.id)" />
            </div>
            <div class="listContTact" >
              <div class="listTTact L">
                <div class="listTTact_title"><b>{{item.realname}}</b></div>
                     <div class="listTTact_desc">{{GetIdcardStr(item.userIdCard)}}</div>
                     <div class="listTTact_line"></div>
                     
              </div>
              <div class="listWTact R">
                <div class="truTact">
                  <i class="iconfont iconlajixiang"></i>
                </div>
              </div>
            </div>
          </li>

        </ul>
      </div>
    </div>
      <div class="bottomheight"></div>
   
    <div class="bottom">
      <div class="item1"  @click="submit">
        <p>确定</p>
      </div>
      <div class="item2" @click="add">
        <p>添加观影人</p>
      </div>
    </div>
  </div>
</template>

<script>

import * as api from "@/api";
import { mapMutations } from "vuex";
import wx from "weixin-js-sdk";
export default {
  name: "filmWrap",
  data() {
    return {
      token: "",
      sign: "",
      num: "",
      docslist: "",
      contact_ids: new Map(),
      contact_num: "",
    };
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
    this.num = this.$route.query.num;
    // this.num = 1;
  },
  computed: {},
  mounted() {
    this.watchUserList();
  },

  methods: {
    // 观影人列表
    async watchUserList() {
      let _this = this;
      try {
        //如果是对象/数组的话，需要先JSON.stringify转换成字符串

        //var encrypts = AES.encrypt(JSON.stringify(cars),keys);
        // var dess = JSON.parse(AES.decrypt(encrypts,keys));
        //var encrypts = AES.encrypt('123',"b57a13b742326a6c");

        //var dess = AES.decrypt(encrypts,"b57a13b742326a6c");
        //alert(encrypts)
        //alert(encrypts.length)
        //alert(dess)

        console.log("token:" + this.token);
        console.log("token:" + this.sign);
        let testToken = "lmojakdhkadocfaccfjocklccdfkhgoj";
        let testSign = "dpbijiiiefibmadgopamipinnnpnphof";
        let num = 3;
        this.num = this.num == undefined ? num : this.num;
        localStorage.setItem(
          "reToken",
          _this.token == undefined ? testToken : _this.token
        );
        const { code, data, message } = await api.user.watchUserList(
          _this.sign == undefined ? testSign : _this.sign
        );

        if (code == "000000") {
          this.docslist = data;
        } else {
          // HyrToast(submsg || msg)
        }
      } catch (err) {
        console.log(err);
      }
    },
     GetIdcardStr(txt){
     
     
      let str = txt;
      str = str.toString().replace(/(\w{4})\w*(\w{3})/,'$1******$2')
    

      return str;
    },
    //选中观影人
    choice: function (e, index, val) {
      let checked = e.target.checked;
      if (checked) {
        if (this.contact_num == "") {
          this.contact_num = 1;
        } else {
          this.contact_num++;
        }
        this.contact_ids.set(val, 1);
      } else {
        this.contact_num--;
        this.contact_ids.delete(val);
      }
    },
    //提交
    submit: function () {
      if (this.num == "" || this.num == undefined || this.num <= 0) {
        alert("选择观影人数");
        return false;
      }
      if (this.contact_ids.size < this.num) {
        alert("选择观影人数少于" + this.num);
        return false;
      } else if (this.contact_ids.size > this.num) {
        alert("只能选择" + this.num + "个观影人");
        return false;
      } else {
        try {
          let dlist = this.docslist;
          let info = [];
          this.contact_ids.forEach(function (value, key) {
            for (var val of dlist) {
              if (val.id == key) {
                info.push(val);
                break;
              }
            }
            console.log("选择观影人:" + JSON.stringify(info));
          });
          //微信环境
          wx.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              wx.miniProgram.navigateBack({
                delta: 1,
              });
              wx.miniProgram.postMessage({
                data: info,
              });
            } else {
              //非小程序环境下逻辑
              alert("只支持小程序访问");
              return false;
            }
          });
        } catch (error) {
          alert(error);
        }
      }
    },
    add:function(){
      let _this = this;
      let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
      let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
      let testNum = _this.num == undefined ? 3 : _this.num;
      window.location.href = "/realname.html#/?token="+testToken+"&sign="+testSign+"&goback=/choiceContact.html&num="+testNum;
    },
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl';
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';

.filmWrapTact {
  background: #f5f5f5;
  height: 100%;

  .paymentLiTact {
    height: auto;
    width: 100%;
    margin: 0 auto;

    .paymentListTact_choicecontact {
      li {
        height: 100px;
        margin-bottom: 15px;
        display: flex;

        .listContTact {
          width: 100%;
          height: 100px;
          background: #fff;
          padding: 40px 20px;
        }

        .listTTact {
          span {
            display: block;
            color: #d3d3d3;
            font-size: 22px;
            padding-top: 15px;
          }

          i {
            vertical-align: middle;
            font-size: 22px;
          }

          em {
            font-size: 28px;
          }

          b {
            font-style: normal;
            padding-left: 20px;
          }
        
         div{
            font-size 28px;
            height 28px;
            line-height 28px;
         }
        


        }
      }
    }

    .paymentListTact_choicecontact .listWTact {
      padding-top: 0px;
      font-size: 22px;
      color: #c1bbbd;

      span {
        padding-left: 20px;

        i {
          font-size: 18px;
        }
      }

      .truTact {
        i {
          font-size: 20px;
        }
      }

      
    }
    .paymentListTact_choicecontact .listContTact{
     .R{
        line-height :20px;
      }  
    }
  }
}

.loginBtnTact {
  width: calc(100% - 150px) calc(100% - 150px);
  height: 90px;
  line-height: 90px;
  background: $background;
  border-radius: 45px;
  font-size: 34px;
  text-align: center;
  color: $color;
  cursor: pointer;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
}

.L {
  float: $floLeft;
}

.R {
  float: $florRight;
}

.checkWrapTact {
  padding: 0 30px 0 30px;
  vertical-align: middle;
  align-self: center;
}

cursor pointer {
  background: none;
}

.listTTact_title{
float:left; 
width:160px;
}


.listTTact_desc{
float:left; 
width:200px;
}


.listTTact_line{
clear:both;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
  margin-right: 10px;
  position: relative;
}

input[type='checkbox']::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background: #d3d3d3;
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

input[type='checkbox']:checked::before {
  content: '\2713';
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px solid #7D7D7D;
  border-radius: 4px;
  color: #7D7D7D;
  font-size: 30px;
  font-weight: bold;
}

.bottom {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 80px;
  text-align: center;
}

.item1 {
  width: 50%;
  background: #ff1734;
  float: left;
}

.item1 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.item2 {
  width: 50%;
  background: #999999;
  float: left;
}

.item2 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.bottomheight {
  height: 100px;
}

</style>



// WEBPACK FOOTER //
// src/view/choiceContact/index.vue